import { Dropdown, Menu, Tooltip } from 'antd'
import SearchInput from 'components/Main/SearchInput'
import SupportTicketDrawer from 'components/Main/SupportTicket/SupportTicketDrawer'
import { GlobalContext } from 'Global'
import React from 'react'
import { Link } from 'react-router-dom'
import Authentication from '../modules/Authentication'

const auth = new Authentication()

export default function Profile() {
  const { collapsed, logo, avatar, member, tenantGroups, tenantGroup, switchTenantGroup } = React.useContext(
    GlobalContext
  )

  const user = {
    username: member.fn,
    avatar,
    logo,
  }

  const menu = (
    <Menu>
      <Menu.Item key="0">
        <Link to={'/account'}>Profile</Link>
      </Menu.Item>
      <Menu.SubMenu key="sub1" title="Switch Group">
        {tenantGroups?.map((i) => (
          <Menu.Item disabled={tenantGroup._id === i._id} key={i.key} onClick={() => switchTenantGroup(i._id)}>
            {i.name} {tenantGroup._id === i._id ? '(Current Group)' : ''}
          </Menu.Item>
        ))}
      </Menu.SubMenu>

      <Menu.Divider />
      <Menu.Item key="3" onClick={auth.logout}>
        Logout
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu}>
      <button className="block w-full flex items-center">
        <img className="h-8 w-8 rounded-full object-cover" src={user.avatar} />
        {!collapsed && (
          <>
            <span className="mx-2 mr-2 text-sm font-medium text-white">{user.username}</span>
            <svg className="ml-auto h-6 w-6 stroke-current text-green-400" viewBox="0 0 24 24" fill="none">
              <path d="M16 10l-4 4-4-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </>
        )}
      </button>
    </Dropdown>
  )
}


